module.exports = __webpack_public_path__ + "img/sv87.16df1503.svg";